import { RoutesState } from "./types";

const state: RoutesState = {
  shownRoutes: [],
  hiddenRoutes: [],
  hiddenItemsWidth: [],
};

export default state;
